import { RentalUnit } from './unit.data';

export interface ParkingData extends RentalUnit {
  /** community only, never with shares */
  apartmentId?: string;
  landRegister?: string;
  type?: ParkingType | null;
}

export enum ParkingType {
  GARAGE = 'garage',
  PARKING_SPOT = 'parking',
  LIFT = 'lift',
  HANDICAPPED_SPOT = 'handicapped',
  OTHER = 'other'
}
